export default __webpack_public_path__ + "ab3bdf4d357b02b29b0717234574a332.svg";